export const GET_USER_CART = 'GET_USER_CART';  // user cart goods

export const ADD_SHOP = 'ADD_SHOP';  // add goods

export const DEL_SHOP = 'DEL_SHOP';  // delete goods

export const REMOVE_ALL_SHOP = 'REMOVE_ALL_SHOP';  // delete all goods

export const CALCULATE_PRICE = 'CALCULATE_PRICE';  // 计算商品总价格

export const REQUEST_ERROR = 'REQUEST_ERROR';  // 计算商品总价格


// WEBPACK FOOTER //
// ./src/reducers/cartReducers/visibility.js